export default {
    refundRecord_00001: "Erstattungsprotokoll",
    refundRecord_00002: "Datum der Rückzahlung",
    refundRecord_00003: "Erstattungsbetrag ({0})",
  }